import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import _ from "lodash";
import { apiPrefix } from '../../config';
export interface IConfig extends AxiosRequestConfig {
  retry?: number;
  responseHandler?: (response: AxiosResponse, next: (res: AxiosResponse) => void) => void;
  errorHandler?: (error: AxiosError, next: (err: AxiosError) => void) => void;
}

const defaultConfig: IConfig = {
  timeout: 60000,
};

const handleResponse = (res: AxiosResponse) => {
  // 处理未登录回调-状态码识别： -30322001: 未登录 ; -30322002: 登录失败
  if (!res.data.success) {
    switch (res.data.errorCode) {
      case -30322001:
      case -30322002:
        break;
    }
  }
};

const handleError = (error: AxiosError) => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        delete sessionStorage.token;
        break;
    }
  } else if (error.request) {
    // The request was made but no response was received
    console.error("Error", error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error("Error", error.message);
  }
  console.error(error.config);
};

export const HttpService = {
  request<T = any>(config: IConfig): Promise<T> {
    const requestConfig = _.defaults(config, defaultConfig); // Merge Configs
    const axiosRequest = _.omit(requestConfig, ["retry", "responseHandler", "errorHandler"]);

    // 统一修改api根路径地址
    axiosRequest.url = `${apiPrefix}${requestConfig.url}`;

    const promise = axios
      .request<T>(axiosRequest)
      .then(res => {
        if (config.responseHandler) {
          config.responseHandler(res, handleResponse);
        } else {
          handleResponse(res);
        }
        return res.data;
      })
      .catch(error => {
        if (config.errorHandler) {
          config.errorHandler(error, handleError);
        } else {
          handleError(error);
        }
        return Promise.reject(error);
      });
    return promise;
  },

  get<T = any>(url: string, data?: any, config: IConfig = {}): Promise<T> {
    const newConfig = { ...config, url, method: "GET" as const, params: data };
    return this.request(newConfig);
  },

  post<T = any>(url: string, data?: any, config: IConfig = {}): Promise<T> {
    const newConfig = { ...config, url, data, method: "POST" as const};
    return this.request(newConfig);
  },

  put<T = any>(url: string, data?: any, config: IConfig = {}): Promise<T> {
    const newConfig = { ...config, url, data, method: "PUT" as const};
    return this.request(newConfig);
  },

  patch<T = any>(url: string, data?: any, config: IConfig = {}): Promise<T> {
    const newConfig = { ...config, url, data, method: "PATCH" as const};
    return this.request(newConfig);
  },

  delete<T = any>(url: string, data?: any, config: IConfig = {}): Promise<T> {
    const newConfig = { ...config, url, method: "DELETE" as const, params: data };
    return this.request(newConfig);
  },
};
